import React, { useEffect, useRef } from "react";
import { Controller } from "react-hook-form";
import $ from "jquery";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css";
import "bootstrap-datepicker";
import moment from "moment";

const DateRangePicker = ({
  control,
  setValue,
  rangeStart,
  startLabel,
  rangeEnd,
  endLabel,
  errors,
  isButton,
  minDate,
  maxDate,
  displayOnMobile,
}) => {
  const startRef = useRef(null);
  const endRef = useRef(null);

  useEffect(() => {
    // Initialize bootstrap-datepicker
    $(startRef.current)
      .datepicker({
        format: "mm/dd/yyyy", // Ensure this matches the expected date format
        autoclose: true,
        todayBtn: "linked",
        startDate: minDate,
        endDate: rangeEnd,
      })
      .on("changeDate", function (e) {
        const selectedDate = e.date;
        setValue(startLabel, selectedDate); // Update start date
        // if (rangeEnd && selectedDate > rangeEnd) {
        //   setValue(endLabel, null); // Reset end date if invalid
        // }
      })
      .on("clearDate", function () {
        setValue(startLabel, null); // Reset start date in React state
      });

    $(endRef.current)
      .datepicker({
        format: "mm/dd/yyyy",
        autoclose: true,
        todayBtn: "linked",
        startDate: rangeStart || null,
        endDate: maxDate,
      })
      .on("changeDate", function (e) {
        setValue(endLabel, e.date); // Update end date
      })
      .on("clearDate", function () {
        setValue(endLabel, null); // Reset end date in React state
      });

    return () => {
      $(startRef.current).datepicker("destroy");
      $(endRef.current).datepicker("destroy");
    };
  }, [setValue, rangeStart, rangeEnd]);

  const formatDate = (date) => {
    if (!date) return "";
    const parsedDate = moment(date, "MM/DD/YYYY", true);
    if (!parsedDate.isValid()) return "";
    return parsedDate.format("MM/DD/YYYY"); // Format date using moment.js
  };

  const handleKeyDown = (event) => {
    const charCode = event.which || event.keyCode;
    // Prevent backspace (8) and non-numeric characters (except control keys below 32)
    if (
      charCode === 8 ||
      (charCode >= 32 && (charCode < 48 || charCode > 57))
    ) {
      event.preventDefault();
      return;
    }
  };

  return (
    <div
      className={`${"btn-toolbar d-flex w-100 justify-content-md-start justify-content-between"}`}
    >
      <li className={`${isButton ? "btn-toolbar-sep d-flex" : "d-flex w-100"}`}>
        {/* Start Date */}
        <Controller
          name={startLabel}
          control={control}
          rules={{
            required: "Start date is required",
          }}
          render={({ field }) => (
            <input
              {...field}
              ref={startRef}
              type="text"
              className={`form-control date-picker w-100-date ${
                errors.rangeStart ? "is-invalid" : ""
              }`}
              placeholder="Start Date"
              value={field.value ? formatDate(field.value) : ""}
              onKeyDown={handleKeyDown}
            />
          )}
        />

        <div className="input-group-addon">TO</div>

        {/* End Date */}
        <Controller
          name={endLabel}
          control={control}
          rules={{
            required: "End date is required",
            validate: (value) =>
              value && value > rangeStart
                ? true
                : "End date must be after start date",
          }}
          render={({ field }) => (
            <input
              {...field}
              ref={endRef}
              type="text"
              className={`form-control w-100-date ${
                errors.rangeEnd ? "is-invalid" : ""
              }`}
              placeholder="End Date"
              value={field.value ? formatDate(field.value) : ""}
              onKeyDown={handleKeyDown}
            />
          )}
        />
      </li>

      {isButton && (
        <li className="btn-toolbar-sep">
          <button
            className="btn btn-primary p-datepicker-mobile"
            onClick={() => {
              setValue(startLabel, null);
              setValue(endLabel, null);
            }}
          >
            Reset
          </button>
        </li>
      )}
    </div>
  );
};

export default DateRangePicker;
